import { Asap } from '@/features/pos/components/OrderFinalization/parts/FormFields/parts/PhoneModeFields/parts/DeliveryTimeSelector/types'
import { formatAsapTime } from '@/features/pos/components/OrderFinalization/parts/FormFields/parts/PhoneModeFields/parts/DeliveryTimeSelector/utils/formats'
import { useIntervaledState } from '@/hooks/useIntervalState'
import { useCallback } from 'react'
import { useTranslation } from 'react-i18next'

export const useFormattedAsapTime = (time: Asap | undefined): string => {
    const { t } = useTranslation()

    const callback = useCallback(() => (time ? formatAsapTime(time, t) : ''), [time, t])

    return useIntervaledState(callback, 60000, !time)
}
